import api from '@mail/api'
import { i18n } from "@appbase/util"

export interface MenuInfo {
    name: string
    id: string
    icon: string
    select: boolean
    expand: boolean
    child?: MenuInfo[]
    path: string,
    type: string,
    wellKnownFolderName?: string

}

const menues: MenuInfo[] = [
    {
        name: i18n.t('메일_홈').toString(),
        id: '',
        icon: 'home2',
        select: false,
        expand: false,
        path: 'mail-home',
        type: 'router-link'
    },
    {
        name: i18n.t('W_Mail_Favorites').toString(),
        id: '',
        icon: 'star',
        select: false,
        expand: true,
        child: [],
        path: 'mail-home',
        type: ''
    }
]

export default menues

export const getMailBoxIcon = function(wellknownFolderName: string): string  {
    var returnIcon;
    switch (wellknownFolderName) {
        case "inbox":
            returnIcon = "inbox";
            break;
        case "sentitems":
            returnIcon = "send";
            break;
        case "outbox":
            returnIcon = "send";
            break;
        case "drafts":
            returnIcon = "box";
            break;
        case "junkemail":
            returnIcon = "denied";
            break;
        case "deleteditems":
            returnIcon = "bin";
            break;
        default:
            returnIcon = "box";
            break;
    }
    return returnIcon;
}

const getFolder = function(parentId: string) {
    api.folder.getFolderTree(parentId).then((res) => {
        res.items.forEach(folder => {
            var folderItem: MenuInfo = {
                name: '',
                id: '',
                icon:'',
                select: false,
                expand: false,
                path: 'mail-list',
                type: 'router-link',
                child: []
            }

            folderItem.name = folder.name
            folderItem.id = folder.id
            folderItem.icon = getMailBoxIcon(folder.wellKnownFolderName ? folder.wellKnownFolderName : '')
            folderItem.wellKnownFolderName = folder.wellKnownFolderName
            folderItem.expand = folder.childFolderCount > 0 ? true : false

            menues.push(folderItem)

            console.log('folder', folder)

            if (folder.hasChildren) {
                makeMenu(folder.children, folderItem)
            }
        })
    })
}

const makeMenu = function (folders: mail.MailboxFolder[] | null, parentMenu: MenuInfo) {
    api.folder.getFolderTree(parentMenu.id).then((res) => {
        res.items.forEach(folder => {
            var folderItem: MenuInfo = {
                name: '',
                id: '',
                icon:'',
                select: false,
                expand: false,
                path: 'mail-list',
                type: 'router-link',
                child: []
            }

            folderItem.name = folder.name
            folderItem.id = folder.id
            folderItem.icon = getMailBoxIcon(folder.wellKnownFolderName ? folder.wellKnownFolderName : '')
            folderItem.wellKnownFolderName = folder.wellKnownFolderName
            folderItem.expand = folder.childFolderCount > 0 ? true : false

            parentMenu.child?.push(folderItem)

            if (folder.hasChildren) {
                makeMenu(folder.children, folderItem)
            }
        })
    })
}

const getFavoriteFolder = function () {
    var favorite = menues.find(x => x.name == i18n.t('W_Mail_Favorites').toString())?.child
    api.favorite.getFavorites().then((res) => {
        res.map((folder: any) => {
            var folderItem: MenuInfo = {
                name: '',
                id: '',
                icon:'',
                select: false,
                expand: false,
                path: 'mail-list',
                type: 'router-link'
            }
            folderItem.name = folder.name
            folderItem.id = folder.id
            folderItem.icon = getMailBoxIcon(folder.wellKnownFolderName)
    
            favorite?.push(folderItem)
        })
    })
}

getFolder('')
getFavoriteFolder()